/// <reference no-default-lib="true" />
/// <reference lib="esnext" />
/// <reference lib="dom" />

function activateYouTubeEmbed(youTubeEmbed: HTMLElement) {
  const iframe = youTubeEmbed.querySelector('iframe')

  if (!iframe) {
    return
  }

  const src = iframe.getAttribute('data-src')

  if (!src) {
    return
  }

  iframe.setAttribute('src', src)
  setTimeout(() => {
    youTubeEmbed.classList.remove('you-tube-embed--placeholder')
  }, 50)
}

export function initYouTubeEmbeds() {
  const youTubeEmbeds = Array.from(document.querySelectorAll('.you-tube-embed'))

  if (youTubeEmbeds.length === 0) {
    return
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        const youTubeEmbed = entry.target as HTMLElement
        activateYouTubeEmbed(youTubeEmbed)
        observer.unobserve(youTubeEmbed)
      })
    },
    { rootMargin: '200px 0px' },
  )

  for (const youTubeEmbed of youTubeEmbeds) {
    if (!(youTubeEmbed instanceof HTMLElement)) {
      continue
    }
    if (youTubeEmbed.dataset.hydrated) continue
    youTubeEmbed.dataset.hydrated = 'true'
    observer.observe(youTubeEmbed)
  }
}
